import { render, staticRenderFns } from "./comp_VariantSelector-SelectItem.vue?vue&type=template&id=1d8cfc65&scoped=true&"
import script from "./comp_VariantSelector-SelectItem.vue?vue&type=script&lang=js&"
export * from "./comp_VariantSelector-SelectItem.vue?vue&type=script&lang=js&"
import style0 from "./comp_VariantSelector-SelectItem.vue?vue&type=style&index=0&id=1d8cfc65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8cfc65",
  null
  
)

export default component.exports